import React, { Component } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
// services
import userService from "services/user.service";
// util
import { cpfMask } from "../../mask/cpf";
import Notifications from "views/Notifications/Notifications";

const styles = (theme) => ({
	cardCategoryWhite: {
		color: "rgba(255,255,255,.62)",
		margin: "0",
		fontSize: "14px",
		marginTop: "0",
		marginBottom: "0",
	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
		marginBottom: "3px",
		textDecoration: "none",
	},
});

class EditarAlunos extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uid: props.uid,
			name: "",
			cpf: "",
			email: "",
			emailError: false,
			notification: { show: false, message: "", type: "info" },
		};

		userService
			.listOneUser(props.uid)
			.then((res) =>
				this.setState({
					name: res.displayName,
					cpf: cpfMask(res.cpf),
					email: res.email,
				})
			)
			.catch((err) => console.error);

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		let value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		if (name === "cpf") value = cpfMask(value);
		if (name === "email") {
			const expression = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			this.setState({ emailError: !expression.test(value) });
		}

		this.setState({
			[name]: value,
		});
	}

	handleSubmit(event) {
		userService
			.updateUser(this.state.uid, {
				name: this.state.name,
				cpf: this.state.cpf
					.replace(".", "")
					.replace(".", "")
					.replace("-", ""),
				email: this.state.email,
			})
			.then((res) =>
				this.showNotification("Aluno editado com sucesso!", "success")
			)
			.catch((err) =>
				this.showNotification(
					"Ocorreu um erro ao tentar editar aluno! " + err,
					"danger"
				)
			);
	}

	showNotification(message, type) {
		this.setState({
			notification: { show: true, message: message, type: type },
		});
		setTimeout(() => {
			this.setState({
				notification: { show: false, message: "", type: "info" },
			});
			this.props.onClose();
		}, 3000);
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
				<GridContainer>
					<GridItem xs={12} sm={12} md={12}>
						<Card>
							<CardHeader color="primary">
								<h4 className={classes.cardTitleWhite}>
									Editar Aluno
								</h4>
								<p className={classes.cardCategoryWhite}>
									Complete as informações para o cadastro
								</p>
							</CardHeader>
							<CardBody>
								<GridContainer>
									<GridItem xs={12} sm={12} md={12}>
										<CustomInput
											labelText="Nome Completo"
											id="name"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "text",
												name: "name",
												value: this.state.name,
												onChange: this.handleChange,
											}}
										/>
									</GridItem>
									<GridItem xs={12} sm={12} md={6}>
										<CustomInput
											labelText="Email"
											id="email"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "email",
												name: "email",
												error: this.state.emailError,
												value: this.state.email,
												onChange: this.handleChange,
											}}
										/>
									</GridItem>
									<GridItem xs={12} sm={12} md={6}>
										<CustomInput
											labelText="CPF"
											id="cpf"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												type: "text",
												name: "cpf",
												value: this.state.cpf,
												onChange: this.handleChange,
											}}
										/>
									</GridItem>
								</GridContainer>
							</CardBody>
							<CardFooter>
								<Button
									color="primary"
									type="submit"
									round
									onClick={(event) => {
										this.handleSubmit(event);
									}}
								>
									Editar
								</Button>
							</CardFooter>
						</Card>
					</GridItem>
					{this.state.notification.show === true ? (
						<Notifications notification={this.state.notification} />
					) : null}
				</GridContainer>
			</div>
		);
	}
}

EditarAlunos.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EditarAlunos);
